export const PRODUCT_APPLICATION_TYPES = [
  'Pintura',
  'Textil',
  'Packaging',
  'Concreto',
  'Recubrimientos industriales',
  'Plásticos',
  'Madera',
  'Papel',
  'Adhesivos',
];

export const STANDARD_KIND_OPTIONS = ['Norma', 'Certificación', 'Método', 'Marco regulatorio'];

export const STANDARD_SECTORS = [
  'Pintura',
  'Textil',
  'Concreto',
  'Packaging',
  'Plástico',
  'Madera',
  'Papel',
  'Adhesivo',
];

export const STANDARD_APPLICATIONS = [
  'In-Can Preservation',
  'Dry-Film Protection',
  'Anticorrosion Additive',
  'Antifouling Biocide',
  'Odor-Control Additive',
];

export const STANDARD_PROPERTIES = [
  'Antihongo',
  'Antiviral',
  'Antibacterial',
  'Anticorrosión',
  'Antiodor',
  'Antifouling',
];

const SECTOR_ALIASES = {
  plasticos: 'Plástico',
  plastico: 'Plástico',
  adhesivos: 'Adhesivo',
  adhesivo: 'Adhesivo',
};

export const normalizeStandardKind = (value = '') => {
  const raw = String(value || '').trim();
  if (!raw) return 'Norma';
  const folded = raw
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
  if (folded === 'certificacion') return 'Certificación';
  if (folded === 'test metodo' || folded === 'metodo' || folded === 'test method') return 'Método';
  if (folded === 'marco regulatorio') return 'Marco regulatorio';
  if (folded === 'norma') return 'Norma';
  return raw;
};

export const normalizeStandardSector = (value = '') => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const folded = raw
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ');
  if (SECTOR_ALIASES[folded]) return SECTOR_ALIASES[folded];
  const exact = STANDARD_SECTORS.find((item) => item.toLowerCase() === folded);
  return exact || raw;
};

const collectValues = (items = [], key, defaults = []) => {
  const extras = items.flatMap((item) => item[key] || []).filter(Boolean);
  return Array.from(new Set([...defaults, ...extras]));
};

export const collectApplicationTypes = (items = []) =>
  collectValues(items, 'applications', PRODUCT_APPLICATION_TYPES);

export const collectStandardSectors = (items = []) =>
  collectValues(
    items.map((item) => ({
      sectors: (item.sectors || []).map(normalizeStandardSector).filter(Boolean),
    })),
    'sectors',
    STANDARD_SECTORS
  );

export const collectStandardApplications = (items = []) =>
  collectValues(items, 'applications', STANDARD_APPLICATIONS);

export const collectStandardProperties = (items = []) =>
  collectValues(items, 'properties', STANDARD_PROPERTIES);
